"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, code = _a.code, _b = _a.square, square = _b === void 0 ? false : _b, _c = _a.asBackground, asBackground = _c === void 0 ? true : _c, _d = _a.width, width = _d === void 0 ? 24 : _d, _e = _a.height, height = _e === void 0 ? 14 : _e;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames_1.default(theme.flag, className, "flag-icon-" + code.toLowerCase(), {
            "flag-icon": !asBackground,
            "flag-icon-background": asBackground,
            "flag-icon-squared": square
        }) }));
});
